<template>
  <el-container style="height: 500px">

    <el-container style="width:20%">
      <el-header style="width: 100%;background-color:white ;padding: 2px 10px 0px" >
        <el-input v-model="inputSearch"
                  placeholder="请输入内容"
                  clearable
                  @input="onInput"></el-input>
      </el-header>
      <el-aside width="100%" style="height: 500px ;background-color: white">
        <el-button size="small" type="primary" @click="creatGroup">创建新图片组</el-button>
        <el-table
          ref="singleTable"
          :data="tableData"
          highlight-current-row
          @current-change="handleCurrentChange"
          style="width: 100%">
          <el-table-column
            property="groupName"
            label="图片分组：">
          </el-table-column>
          <el-table-column
            fixed="right"
            width="50">
            <template slot-scope="scope">
              <i class="el-icon-edit" @click="editGroup(scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>
      </el-aside>
    </el-container>
    <el-container style="width: 80%">
      <el-header style="text-align: left; background-color: white" >
        <el-upload action="#" :show-file-list="false" :http-request="uploadNewPhoto">
          <el-button size="small" type="primary">上传新图片</el-button>
          <!--          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>-->
        </el-upload>
      </el-header>
      <el-main>
        <el-row :gutter="20">
          <el-col :span="24" :lg="4" :md="6" :sm="8" v-for="(item,index) in imageList" :key="index">
            <el-card :body-style="{ padding: '0px' } " shadow="hover">
              <div class="border" :class="{'border-danger':item.ischeck}">
                <div class="box" @click="choose(item)">
                  <span style="position:absolute;background: #67C23A ;width: 20px;text-align: center;border-radius: 0px 0px 3px 0px;"
                        v-if="item.ischeck">{{item.checkOrder}}</span>
                  <img :src="item.fileUrl" style="margin:0px 0px"/>
                  <div style="width: 140px;height:20px;
                  background:rgba(255,255,255,0);margin:-15px 2px;position: absolute;">
                    <span v-text="getSubStr(item.name)"></span>
                  </div>
                </div>
              </div>

            </el-card>
          </el-col>
        </el-row>
      </el-main>
    </el-container>

    <el-dialog title="创建新图片组" :visible.sync="dialogCreatGroup" append-to-body>
      <el-form>
        <el-form-item label="图片组名称">
          <el-input v-model="currentGroupName" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="danger" @click="deleteGroupAction" v-if="currentGroupId !== -1">删 除 分 组</el-button>
        <el-button @click="dialogCreatGroup = false">取 消</el-button>
        <el-button type="primary" @click="updateGroupAction">确 定</el-button>
      </div>
    </el-dialog>

  </el-container>
</template>

<script>
import {getPhotoGroup,getPhotosInGroup,upLoadPhotosInGroup} from "../../api/photoRequest";
import {creatGroup, deleteGroup, updateGroup} from "../../api/homePageRequest";
import {getToken} from "../../utils/auth";
export default {
  name: "PickPhotoAlert",
  data() {
    return {
      inputSearch: '',
      timer: null,   // 这里放外面其实不安全，容易被篡改
      resultList: [],   // 最终要渲染的内容数组
      isShow: false,    // 控制下拉列表的显示与隐藏
      tableData:[],
      originData: [],
      imageList:[],
      chooseList: [],
      currentRow :0,
      dialogCreatGroup :false,
      currentGroupName:'',
      currentGroupId:-1,
    }
  },
  props:{
    maxSelected:{
      type:Number,
      default:1
    }
  },
  created() {
    this.tableData = this.originData
    this.getGroup()
  },
  methods: {
    getSubStr (str){
      var clipStr = str.split('.')[0]
      var subStr1 = clipStr.substr(0,2);
      var subStr2 = clipStr.substr(clipStr.length-5,5);
      var subStr = subStr1 + "..." + subStr2 ;
      return subStr;
    },

    updateGroupAction(){
      if (this.currentGroupId === -1){
        creatGroup({"groupName":this.currentGroupName,"groupType":"photo"}).then(res => {
          this.$message({
            type: 'success',
            message: '创建成功！'
          });
          this.currentGroupName = ''
          this.currentGroupId = -1
          this.dialogCreatGroup = false
          this.getGroup()
        })
      } else {
        updateGroup({
          "groupId":this.currentGroupId,
          "groupName":this.currentGroupName
        }).then( response => {
          this.$message({
            type: 'success',
            message: '更新成功！'
          });
          this.currentGroupName = ''
          this.currentGroupId = -1
          this.dialogCreatGroup = false
          this.getGroup()
        })
      }
    },
    deleteGroupAction(){
      if (this.currentGroupId === -1) return
      deleteGroup(this.currentGroupId).then( res => {
        this.$message({
          type: 'success',
          message: '删除成功！'
        });
        this.currentGroupName = ''
        this.currentGroupId = -1
        this.dialogCreatGroup = false
        this.getGroup()
      })
    },
    editGroup(group){
      this.currentGroupName = group.groupName
      this.currentGroupId = group.groupId
      this.dialogCreatGroup = true
    },
    creatGroup(){
      this.currentGroupName = ''
      this.currentGroupId = -1
      this.dialogCreatGroup = true
    },
    // 选中图片
    choose(item) {
      // 选中功能
      if (!item.ischeck) {
        if (!(this.chooseList.length < this.maxSelected)) {
          this.$message.error('最多选择' + this.maxSelected + '张')
          return
        }
        this.chooseList.push({
          fileBid: item.fileBid,
          fileUrl: item.fileUrl,
          name:item.name
        });
        item.checkOrder = this.chooseList.length;
        item.ischeck = true;
        return;
      } else {
        // 取消选中
        // 找到在chooseList中的索引，删除
        let i = this.chooseList.findIndex(v => v.fileBid === item.fileBid);
        if (i === -1) return;
        // 重新计算序号
        let length = this.chooseList.length;
        // 取消选中中间部分
        if (i + 1 < length) {
          for (var j = i; j < length; j++) {
            let no = this.imageList.findIndex(
              v => v.fileBid === this.chooseList[j].fileBid
            );
            if (no > -1) {
              this.imageList[no].checkOrder--;
            }
          }
        }
        this.chooseList.splice(i, 1);
        item.ischeck = false;
        item.checkOrder = 0;
      }

    },
    setCurrent(row) {
      this.$refs.singleTable.setCurrentRow(row);
    },
    handleCurrentChange(val) {
      this.imageList = []
      this.currentRow = val;
      getPhotosInGroup(val.groupId).then(response => {
        let images = []
        for (let i=0; i < response.data.records.length; i++) {
          let item = response.data.records[i]
          item.ischeck = false
          item.checkOrder = 0
          images.push(item)
        }
        this.imageList = images
      })
    },
    onInput() {
      this.isShow = true
      // 防抖
      if(this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(()=>{
        this.fSearch()
      },200)
    },
    fSearch(){
      this.tableData = this.originData
      if (this.inputSearch.length > 0){
        var currentDatas = []
        for (let i=0; i < this.tableData.length; i++) {
          let item = this.tableData[i]
          if (item.date.includes(this.inputSearch)){
            currentDatas.push(item)
          }
        }
        this.tableData = currentDatas
      }
    },
    handleSelect(item) {
      this.obj[this.name] = item.id+''   // 选中后给对应字段赋值
      this.isShow = false   // 选中某一项后隐藏下拉列表框
    },
    getGroup(){
      getPhotoGroup().then(response => {
        this.originData = response.data
        this.tableData = this.originData
        this.handleCurrentChange(response.data[0])
      });
    },
    uploadNewPhoto(item){
      let groupId = this.currentRow.groupId
      let formData = new FormData()
      formData.append('file', item.file)
      upLoadPhotosInGroup(groupId,item.file.name,formData,getToken()).then((req, res ) => {
        this.handleCurrentChange(this.currentRow)
      }).catch(error => {
        this.$message.error('上传失败，请重新上传')
        console.log('报错', error)
      })
    },
    imageEdit(item,index){

    }
  }
}
</script>

<style lang="scss" scoped>

.border{
  border: 2px solid white;
}
.border-danger{
  border: 2px solid #67C23A;
}
.el-card {
  margin-bottom: 20px;
}
.box {
  width: 100%;
  height: 120px;
  background: aliceblue;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
